class SectionFaqsSwatches extends HTMLElement {
  constructor() {
    super();
    this.tabheading = this.querySelectorAll('.tabheading_btn');
    this.tabdetails = this.querySelectorAll('.faq-Faqs_ColumnWrapper');
    this.tabContents = this.querySelector('.faq-Faqs_tabContents');
    this.flickityInstance = null;
    this.isDesktop = window.innerWidth > 900;
    this.onResize = this.handleResize.bind(this);

    if (!this.tabheading.length) return;

    this.init();
  }

  init() {
    this.tabheading.forEach((tab, i) => {
      const tabContentId = tab.getAttribute('data-id');
      const tabContentEle = this.querySelector(`#${tabContentId}`);
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.activateTab(i);
      });
      if (tabContentEle) {
        this.initFaqs(tabContentEle);
      }
    });

    setTimeout(() => {
      this.initFlickity();
    }, 100);

    window.addEventListener('resize', this.onResize);
  }

  isDesktopView() {
    return window.innerWidth > 900;
  }

  getActiveTabIndex() {
    const activeIndex = Array.from(this.tabheading).findIndex((tab) => tab.classList.contains('active'));
    return activeIndex === -1 ? 0 : activeIndex;
  }

  setActiveHeading(index) {
    this.tabheading.forEach((tab, i) => {
      tab.classList.toggle('active', i === index);
    });
  }

  setDesktopTabVisibility(index) {
    this.tabdetails.forEach((item, i) => {
      item.classList.toggle('hidden', i !== index);
    });
  }

  revealAllTabPanels() {
    this.tabdetails.forEach((item) => {
      item.classList.remove('hidden');
    });
  }

  activateTab(index) {
    this.setActiveHeading(index);

    if (this.flickityInstance) {
      this.flickityInstance.select(index);
      return;
    }

    this.setDesktopTabVisibility(index);
  }

  handleResize() {
    const newIsDesktop = this.isDesktopView();
    if (newIsDesktop !== this.isDesktop) {
      this.initFlickity();
      return;
    }

    if (this.flickityInstance) {
      this.flickityInstance.resize();
    }
  }

  initFlickity() {
    if (!this.tabContents) return;

    try {
      const wasDesktop = this.isDesktop;
      this.isDesktop = this.isDesktopView();
      const activeIndex = this.getActiveTabIndex();

      if (this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }

      if (this.isDesktop) {
        this.setDesktopTabVisibility(activeIndex);
        return;
      }

      this.revealAllTabPanels();

      this.flickityInstance = new Flickity(this.tabContents, {
        cellSelector: '.faq-Faqs_ColumnWrapper',
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        wrapAround: false,
        cellAlign: 'left',
        contain: true,
        transitionDuration: 300
      });

      this.flickityInstance.select(activeIndex);

      this.flickityInstance.on('change', (index) => {
        this.setActiveHeading(index);
      });

      if (wasDesktop !== this.isDesktop) {
        this.flickityInstance.resize();
      }
    } catch (error) {
      console.error('Error initializing FAQs:', error);
    }
  }

  initFaqs(accordion) {
    const items = accordion.querySelectorAll('[data-el="accordion.item"]');
    const triggers = accordion.querySelectorAll('[data-el="accordion.trigger"]');

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        const item = items[index];
        if (!item) return;

        const body = item.querySelector('[data-el="accordion.body"]');
        const isOpen = item.getAttribute('aria-expanded') === 'true';
        item.setAttribute('aria-expanded', !isOpen);
        body.classList.toggle('open', !isOpen);

        setTimeout(() => {
          if (this.flickityInstance) {
            this.flickityInstance.resize();
          }
        }, 100);
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
      this.flickityInstance = null;
    }
  }
}

customElements.define('faqs-swatches', SectionFaqsSwatches);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-Faqs_Items--left:empty, .faq-Faqs_Items--right:empty').forEach((column) => {
    column.style.display = 'none';
  });
});
